/**
 * @name FacetSearchBar.View.js
 *
 * @author Anchor Group : Brandon Doser <bdoser@anchorgroup.tech>
 * 
 * @since last updated date 2024-07-12
 * 
 * @file The main function of this View is to get the right values to each searchbar for each Facet Option. It also sets up the event to check when the value in a
 * search bar changes. It will trigger the model event from the Entry when the limitResults function runs.
 */

define('FacetSearchBar.View',
	[
		'facetsearchbar.tpl',
		'Backbone'
	],
	function (
		facetsearchbar_tpl,
		Backbone
	) {
		'use strict';

		return Backbone.View.extend({

			template: facetsearchbar_tpl,

			initialize: function (options) {
				this.model = options.model;
				this.facetId = options.facetId;
			},

			events: {
				'keydown [data-action="limitResults"]': 'limitResults'
			},

			/**
			 * Sets model attributes for the model from the entry point. Triggers the model event for it to determine which options to hide based on searchbar text
			 * 
			 * @function limitResults
			 */
			limitResults: _.debounce(function () {
				//Trigger the model event by setting the inputText attribute.
				this.model.set('facetId', this.facetId);
				this.model.set('inputText', document.getElementById(this.facetId).value);
			}, 300),

			getContext: function getContext() {
				let oldInputText;
				if (this.model.get('facetId') == this.facetId) {
					oldInputText = this.model.get('inputText');
				} else {
					oldInputText = '';
				}
				return {
					facetId: this.facetId, oldInputText: oldInputText
				};
			}
		});
	});
